import { render, staticRenderFns } from "./CustomFieldInput.vue?vue&type=template&id=77e88fef&scoped=true"
import script from "./CustomFieldInput.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomFieldInput.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e88fef",
  null
  
)

export default component.exports